import { getVm } from '@/helpers/vm-helper';

import { SportEventV2 } from '@/@types/graphql-types';
import { competitionHeader } from '@/components/sports/all/all-translatables';
import { TimeGroup } from '@/components/sports/types';
import type { SingleStepOverviewContext } from '@/helpers/sports/config';

export interface SpinningBlock {
	header: string;
	body: string[];
}

export interface SportOverviewSpinningTextOptions {
	context: SingleStepOverviewContext;
	// all the events
	events: SportEventV2[];
	// only the events with the given time group
	data: { events: SportEventV2[]; timeGroup: TimeGroup };
	country: string;
	language: string;
}

export function getOverviewSportSpinningText({
	context,
	data,
	events,
	country,
	language,
}: SportOverviewSpinningTextOptions) {
	const vm = getVm();

	const blockData = {
		country,
		events: data.events,
		sport: vm.$t(context.sportName),
		timeFormatter: getTimeFormatter(language),
		dateFormatter: getDateFormatter(language),
		listFormatter: getListFormatter(language),
	};

	const spinningText: SpinningBlock[] = [
		{
			header: '',
			body: [vm.$t(context.subheading)],
			// body: [vm.$t(context.subheading), vm.$t('SPORTS_WEBAPP_SPIN_OVERVIEW_BODY', { sport: blockData.sport })],
		},
	];

	// spinningText.push(
	// 	SportOverview.getLiveBlock(blockData, {
	// 		noEvents: data.timeGroup === 'upcoming' || data.events.length === 0,
	// 		hasEventToday: data.timeGroup === 'today',
	// 		hasEventNow: data.timeGroup === 'live',
	// 		vm,
	// 	})
	// );

	// spinningText.push(
	// 	SportOverview.getUpcomingBlock(blockData, {
	// 		noEvents: data.timeGroup !== 'upcoming' || data.events.length === 0,
	// 		hasUpcoming: data.timeGroup === 'upcoming',
	// 		vm,
	// 	})
	// );

	// const freeEvents = events.filter(event =>
	// 	event.offers.some(offer => offer.monetizationType === MonetizationType.Free)
	// );
	// if (freeEvents.length > 0) {
	// 	spinningText.push(SportOverview.getFreeBlock({ ...blockData, events: freeEvents }, { vm }));
	// }

	return spinningText;
}

export interface SportCompetitionSpinningTextOptions {
	objectId: number;
	competition: string;
	// all the events
	events: SportEventV2[];
	// only the events with the given time group
	data: { events: SportEventV2[]; timeGroup: TimeGroup };
	country: string;
	language: string;
}

export function getCompetitionSportSpinningText({
	objectId,
	competition,
	data,
	events,
	country,
	language,
}: SportCompetitionSpinningTextOptions) {
	const vm = getVm();

	const blockData = {
		country,
		competition,
		events: data.events,
		timeFormatter: getTimeFormatter(language),
		dateFormatter: getDateFormatter(language),
		listFormatter: getListFormatter(language),
	};

	const spinningText: SpinningBlock[] = [];

	const hardcodedText = competitionHeader?.[language]?.[objectId];
	if (hardcodedText) spinningText.push({ header: '', body: [hardcodedText] });

	// spinningText.push(
	// 	SportCompetition.getLiveBlock(blockData, {
	// 		noEvents: data.timeGroup === 'upcoming' || data.events.length === 0,
	// 		hasEventToday: data.timeGroup === 'today',
	// 		hasEventNow: data.timeGroup === 'live',
	// 		vm,
	// 	})
	// );

	// spinningText.push(
	// 	SportCompetition.getUpcomingBlock(blockData, {
	// 		noEvents: data.timeGroup !== 'upcoming' || data.events.length === 0,
	// 		hasUpcoming: data.timeGroup === 'upcoming',
	// 		vm,
	// 	})
	// );

	// const freeEvents = events.filter(event =>
	// 	event.offers.some(offer => offer.monetizationType === MonetizationType.Free)
	// );
	// if (freeEvents.length > 0) {
	// 	spinningText.push(SportCompetition.getFreeBlock({ ...blockData, events: freeEvents }, { vm }));
	// }

	return spinningText;
}

// COMMON FUNCTONS
export function getCompetitionList(events: SportEventV2[]) {
	return [...new Set(events.map(event => event.competition?.content.name).filter((name): name is string => !!name))];
}

export function getEventStreamingService(event: SportEventV2) {
	return (
		event.watchNowOffer?.package.clearName ??
		event.offers.find(offer => offer.package.clearName != null)!.package.clearName
	);
}

export function getListFormatter(language: string) {
	// @ts-ignore the ts linter doesn't know about Intl.ListFormat
	return new Intl.ListFormat(language, { style: 'long', type: 'conjunction' }) as unknown as {
		format: (list: string[]) => string;
	};
}

export function getDateFormatter(language: string) {
	return new Intl.DateTimeFormat(language, { day: '2-digit', month: 'short' });
}

export function getTimeFormatter(language: string) {
	return new Intl.DateTimeFormat(language, { hour: '2-digit', minute: '2-digit' });
}
